export const requestsMixin = {
    filters: {
        ctype(value) {
            return { "INTERNAL" : "Compra Interna", "DEFAULT" : "Cotação", null: 'Cotação' }[value]
        }
    }
}